import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

import { switchOrgAction } from '@/components/organizations/actions';
import { useAuth } from '@/context/AuthContext';
import { useAdvisorPractices } from '@/hooks/useAdvisorPractices';
import { takePostLoginPath } from '@/lib/post-login-path';

export default function HomeRedirect() {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const { practices, isAnswered } = useAdvisorPractices();
  const [ready, setReady] = React.useState(false);
  const returnTo = React.useRef<string | null>(null);

  const practice = practices[0];

  const settled = !authLoading && (!isAuthenticated || isAnswered);

  React.useEffect(() => {
    if (!settled) return;
    returnTo.current = takePostLoginPath();
    if (!practice) {
      setReady(true);
      return;
    }
    switchOrgAction({ orgId: practice.organization_id })
      .catch(() => undefined)
      .finally(() => setReady(true));
  }, [settled, practice]);

  if (!settled || !ready) {
    return (
      <div className="flex min-h-screen w-full items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return <Navigate to={returnTo.current ?? (practice ? '/advisor' : '/dashboard')} replace />;
}
